import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { ServerLicense, ServerLicenseResults, ServerLicenseSearchParams } from '@atlassian/cssxp-typescommon';
import { isNil, omitBy } from 'lodash';

const client = createAxiosClient({ baseURL: '/api/1/server-licenses' }, ServiceProxyMap.ANS);

export async function fetchServerLicense(sen: string): Promise<ServerLicense> {
  const response = await client.get(`/${sen}`);

  return response.data;
}

export async function serverLicensesSearch(searchParams: ServerLicenseSearchParams): Promise<ServerLicenseResults> {
  const params = {
    ...searchParams,
    sort: [{ maintenanceActive: 'asc' }, { productName: 'asc' }, ...(searchParams?.sort ?? [])],
  };
  const response = await client.get('/', {
    params: omitBy(params, isNil),
  });
  return response.data;
}
